"use client"

import {
  StatusBadge as StatusBadgePrimitive,
  type StatusBadgeProps,
} from "@exxatdesignux/ui/components/ui/status-badge"

/** Semantic icon + label chips default to md unless size is explicit. */
export function StatusBadge(props: StatusBadgeProps) {
  if (props.status !== undefined) {
    return <StatusBadgePrimitive {...props} />
  }

  const { size, icon, ...rest } = props
  return (
    <StatusBadgePrimitive
      {...rest}
      icon={icon}
      size={size ?? (icon ? "md" : undefined)}
    />
  )
}
